import { render } from "./FilePreview.vue?vue&type=template&id=2469e52b&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"

import "@/Common/Styles/fileInput.scss?vue&type=style&index=0&id=2469e52b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2469e52b"]])

export default __exports__